import React from 'react';

import Search from '../SearchBriefings';
import CardValue from '../CardValue';

import './style/dashboard.scss';

const Dashboard = () => (
	<div className="componentDashboard pt-4">
		<div id="main">
			<div className="container">
				<div className="row">
					<div className="col-12">
						<div className="container-title-dashboard">
							<h2 className="title">PARA FAZER HOJE</h2>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-12">
						<Search />
					</div>
				</div>

				<div className="row">
					<div className="col-12 col-md-6 col-sm-6 mb-4">
						<CardValue side1="CREATIVOS" side2="24" />
					</div>

					<div className="col-12 col-md-6 col-sm-6 mb-4">
						<CardValue side1="PENDÊNCIA DE BRIEFINGS" side2="15" />
					</div>
				</div>

				<div className="row">
					<div className="col-12 col-md-6 col-sm-6 mb-4">
						<CardValue side1="CREATIVOS" side2="45" />
					</div>

					<div className="col-12 col-md-6 col-sm-6 mb-4">
						<CardValue side1="DESENVOLVENDO CAMPANHAS" side2="120" />
					</div>
				</div>

				<div className="row">
					<div className="col-12 col-md-6 col-sm-6 mb-4">
						<CardValue side1="DESENVOLVENDO CAMPANHAS" side2="31" />
					</div>

					<div className="col-12 col-md-6 col-sm-6 mb-4">
						<CardValue side1="OTIMIZANDO CAMPANNHAS" side2="88" />
					</div>
				</div>

				<div className="row">
					<div className="col-12 col-md-6 col-sm-6 mb-4">
						<CardValue side1="CAMPANHAS FINALIZADAS" side2="31" />
					</div>

					<div className="col-12 col-md-6 col-sm-6 mb-4">
						<CardValue side1="CAMPANHAS DESCARTADAS" side2="3" />
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default Dashboard;
